import { render } from "./login.vue?vue&type=template&id=52f2fd47&scoped=true"
import script from "./login.vue?vue&type=script&lang=js"
export * from "./login.vue?vue&type=script&lang=js"

import "./login.vue?vue&type=style&index=0&id=52f2fd47&rel=stylesheet%2Fscss&lang=scss"
import "./login.vue?vue&type=style&index=1&id=52f2fd47&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52f2fd47"]])

export default __exports__